<template>
    <BasicTabs :tabs="tabs" :tab-key="tabKey">
        <template #header>
            <inertia-link :href="route('kiosk.teams.index')">
                <AtomicButton color="yellow" class="mt-[27px]" size="sm">
                    {{ $t("vue.back_to_all_teams") }}
                    <template #icon>
                        <BackspaceIcon
                            class="mr-2 h-6 w-6 transition duration-200 group-hover:text-gray-600"
                        />
                    </template>
                </AtomicButton>
            </inertia-link>

            <TeamTabsProfile :selected-team="selectedTeam" />
        </template>

        <slot />
    </BasicTabs>
</template>

<script lang="ts" setup>
import {
    BackspaceIcon,
    UserGroupIcon,
    AdjustmentsVerticalIcon,
    ShieldExclamationIcon,
    GlobeAltIcon,
} from "@heroicons/vue/24/solid";

import route from "ziggy-js";
import type TabItem from "@/types/Settings/TabItem";
import type ICurrentTeam from "@/types/Members/ICurrentTeam";
import { useTranslations } from "@/composables/useTranslations";

interface TeamTabProps {
    tabKey: string;
    selectedTeam: ICurrentTeam;
}

const props = withDefaults(defineProps<TeamTabProps>(), {
    tabKey: "members",
});

const { t } = useTranslations();

const tabs: TabItem[] = [
    {
        title: t("vue.members"),
        key: "members",
        icon: UserGroupIcon,
        url: route("kiosk.teams.members.index", {
            team: props.selectedTeam.id,
        }),
    },
    {
        title: t("vue.features"),
        key: "feature-management",
        icon: AdjustmentsVerticalIcon,
        url: route("kiosk.teams.feature-management.index", {
            team: props.selectedTeam.id,
        }),
    },
    {
        title: t("vue.blocked_actions"),
        key: "team-blocked-actions",
        icon: ShieldExclamationIcon,
        url: route("kiosk.teams.blocked-actions.index", {
            team: props.selectedTeam.id,
        }),
    },
    {
        title: t("vue.user_domains"),
        key: "team-domains",
        icon: GlobeAltIcon,
        url: route("kiosk.teams.teams-domains.index", {
            team: props.selectedTeam.id,
        }),
    },
];
</script>
